<!-- file migrated to packages/base/components/lead-collector/lead-collector-success.vue on branch main -->

<template>
  <div
    :class="[
      'lead-collector-success',
      `lead-collector-success--${orientation}`
    ]"
  >
    <div
      :class="[
        'lead-collector-success__content',
        `lead-collector-success__content--${orientation}`
      ]"
    >
      <z-title
        tag="div"
        size="medium"
      >
        {{ $t('success.title') }}
      </z-title>

      <z-text
        tag="p"
        :class="`lead-collector-success__text--${orientation}`"
        align="left"
      >
        {{ $t('success.description') }}
      </z-text>
    </div>
    <img
      :class="`lead-collector-success__icon--${orientation}`"
      :alt="$t('icon-alt')"
      src="https://kong.quero.com/pi05aa08ui_001.svg"
    >
  </div>
</template>

<script>
import { shouldBeOneOf } from 'vue-prop-validation-helper'
import messages from './i18n/lead-collector-section.json'

export default {
  name: 'LeadCollectorSuccess',
  props: {
    orientation: {
      type: String,
      required: true,
      validator: shouldBeOneOf(['vertical', 'horizontal']),
    },
  },
  i18n: {
    messages: {
      'pt-BR': messages,
    },
  },
}
</script>

<style lang="scss" scoped>
.lead-collector-success {
  text-align: center;
}

.lead-collector-success--horizontal {
  @media (min-width: $breakpoint-tablet) {
    align-items: center;
    display: flex;
    text-align: left;
    justify-content: center;
    min-height: 168px;
  }
}

.lead-collector-success__icon--vertical {
  height: var(--unit-2000);
  margin-left: auto;
  margin-right: auto;
  width: var(--unit-2000);
}

.lead-collector-success__icon--horizontal {
  @media (max-width: $breakpoint-phone-max) {
    margin-left: auto;
    margin-right: auto;
  }
}

.lead-collector-success__content--horizontal {
  @media (min-width: $breakpoint-tablet) {
    margin-left: var(--unit-0400);
  }
}

.lead-collector-success__content--vertical {
  margin-top: var(--unit-0800);

  @media (min-width: $breakpoint-tablet) {
    margin-top: var(--unit-0600);
  }
}

.lead-collector-success__text--vertical {
  text-align: center;
}

.lead-collector-success__text--horizontal {
  text-align: center;

  @media (min-width: $breakpoint-tablet) {
    margin-bottom: 0;
    text-align: left;
  }
}
</style>
